import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-22" data-mp="2hf4lkrab19s1">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-23" data-mp="2m9h6z6vccv6f">
        <div className="mb-6 text-center" data-id="element-24" data-mp="2q9j6b9dltcij">
          <SectionTag icon="⚽" data-id="element-25" data-mp="2q99fxkond3cb">Acerca de Manuales Listos</SectionTag>
        </div>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-white/10 bg-bg-primary p-8 text-center sm:p-10" data-id="element-26" data-mp="1tkjwhpxdg2o8">
          <QuoteIcon size={28} className="mx-auto text-lime" data-id="element-27" data-mp="27jjmp20j8pmi" />
          <p className="mt-4 text-lg italic leading-relaxed text-white sm:text-xl" data-id="element-28" data-mp="27gx509jxgtqk">
            "He volcado en este sistema los esquemas reales que utilizamos para transformar entrenamientos
            improvisados en sesiones con criterio profesional. Menos búsqueda en YouTube y más fútbol real
            en el campo."
          </p>
          <div className="mx-auto mt-6 max-w-xl border-t border-white/10 pt-4" data-id="element-29" data-mp="25ryubdtnrw3s">
            <p className="font-heading text-base font-semibold text-white" data-id="element-30" data-mp="20svqtxtbtxxx">El Equipo de MISTER PRO</p>
            <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-31" data-mp="1vuawug4o4ahx">
              Entrenadores de fútbol formativo con más de una década de experiencia en categorías
              formativas. Formados en el campo de tierra, en el vestuario ruidoso y en la reunión de
              padres difícil.
              Todo lo que encontrarás en MISTER PRO viene de ahí. No de la teoría. Del campo real.
            </p>
          </div>
        </m.div>
      </div>
    </section>;
}